<section class="ldg-banner" id="top">
  <article>
    <div class="relative-left full-width ldg-banner-bg {{system}}-{{lottoId}}-bg {{system}}-{{lottoId}}-bg-{{'lang' | translate}}">
      <div class="ldg-jackpot-wrap absolute left-0 full-width full-height">
        <div class="content-wrap txt-center full-height">
          <div class="absolute bottom-0 left-0 full-width ldg-jackpot-content" [ngClass]="{'cash':lottoId ==48}">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
    <h2 class="ldg-banner-promo-text ldg-banner-promo-text-{{lottoId}}-{{system}} relative-left full-width txt-center">
      <span>{{'PERCENT' | translate}}</span> {{'PERCENT-TEXT' | translate}}
    </h2>
  </article>
</section>
